import Translate from '@/filters/translate'

export default {
  name: 'contact-form',
  data () {
    return {
      errorMessage: '',
      formSent: false
    }
  },
  computed: {
    email: {
      set (value) { this.$store.dispatch('setContactEmail', value) },
      get () { return this.$store.getters.contactEmail }
    },
    subject: {
      set (value) { this.$store.dispatch('setContactSubject', value) },
      get () { return this.$store.getters.contactSubject }
    },
    message: {
      set (value) { this.$store.dispatch('setContactMessage', value) },
      get () { return this.$store.getters.contactMessage }
    },
    disabled () {
      return !this.$store.getters.contactEmailIsValid ||
        this.$store.getters.contactSubjectIsEmpty ||
        this.$store.getters.contactMessageIsEmpty
    }
  },
  methods: {
    send () {
      // Reset error message.
      this.errorMessage = ''

      let self = this

      // Set backdrop message etc.
      this.$store.dispatch('setAllowClosingBackdrop', true)
      this.$store.dispatch('setBackdropMessage', Translate.translate(this.$store.getters.contactState))
      this.$store.dispatch('showBackdrop', true)

      this.$store.dispatch('setContactState', 'sendingMessage')
      this.$store.dispatch('sendMessage').then(function (response) {
        self.$store.dispatch('showBackdrop', false)
        self.formSent = true
        self.email = ''
        self.subject = ''
        self.message = ''
      }).catch(function (response) { self.handleContactError(response, 'sendMessage') })
    },

    handleContactError (response, location) {
      this.$store.dispatch('setAllowClosingBackdrop', true)
      this.$store.dispatch('showBackdrop', false)

      // Where the error occurred.
      switch (location) {
        case 'sendMessage':
          console.log('error in location \'' + location + '\'')
          break
      }

      // Make the error prepended by 'error' and make the location upper-case first, to match the translation strings:
      // sendMessage --> errorSendMessage
      this.errorMessage = 'error' + location.substr(0, 1).toUpperCase() + location.substr(1) // @todo Specific errors?

      // Scroll to top.
      document.querySelector('body').scrollIntoView()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/contact-form/script.js